import log from 'loglevel'

export default class LocalStorage {
    static getItem(key) {
        try {
            const value = valueFromStorageString(localStorage.getItem(key))
            log.debug(`💾 localStorage read: ${key} =`, value)
            return value
        } catch (e) {
            log.error(e)
        }
    }

    static getAll() {
        try {
            return Object.keys(localStorage).map(key => LocalStorage.getItem(key))
        } catch (e) {
            log.error(e)
        }
    }

    static setItem(key, value) {
        try {
            const str = valueToStorageString(value)
            localStorage.setItem(key, str)
            log.debug(`💾 localStorage write: ${key} =`, str)
        } catch (e) {
            log.error(e)
        }
    }

    static removeItem(key) {
        localStorage.removeItem(key)
    }
}

function valueToStorageString(value) {
    switch (typeof value) {
        case 'object':
            return JSON.stringify(value)
        case 'undefined':
            return '' // JSON.parse can't process the real undefined
        default:
            return value
    }
}

function valueFromStorageString(str) {
    try {
        return str === '' ? undefined : JSON.parse(str) // handle 'undefined', as seen above
    } catch { // if we can't parse JSON, we just use the string value
        return str
    }
}
